<template>
  <div class="flex flex-col" :class="size">
    <slot name="label">
      <label :for="props.name" :class="props.classes">{{ label }}</label>
    </slot>
    <slot :value="value">
      <InputText :name="props.name" :id="props.name" type="text" class="h-10" v-model="value" :disabled="props.disabled" />
    </slot>
  </div>
</template>

<script setup lang="ts">
interface Props {
  name: string;
  label: string;
  size?: string;
  classes?: string;
  disabled?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  size: "w-full",
  classes: "font-bold",
  disabled: false,
});

const value = defineModel<string>({ required: true });
</script>
